import React from 'react'

function FormErrorMessage({ message, className="" }) {
  return (
   <div aria-atomic="true" role="alert" className={`form-layout-message-error ${className}`}>{message}</div>
  )
}

export default FormErrorMessage
